import { render, staticRenderFns } from "./callRecordDetail.vue?vue&type=template&id=9fa3f98a&scoped=true&"
import script from "./callRecordDetail.vue?vue&type=script&lang=ts&"
export * from "./callRecordDetail.vue?vue&type=script&lang=ts&"
import style0 from "./callRecordDetail.vue?vue&type=style&index=0&id=9fa3f98a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa3f98a",
  null
  
)

export default component.exports